import { HistoryProrvider } from './historyProrvider';
import { getUserStateStorage } from '../../common/utils/local-storage/user-state';

const _history = HistoryProrvider.getHistory();

export class Navigator {

  public static openAudio(groupId: number, audioId: number, tab?: string) {
    const w = window as any;
    w.back = w.location.href;
    const userStorage = getUserStateStorage();
    userStorage.setAudioInfo(audioId, groupId);
    userStorage.setLibraryGroupId(groupId);

    const url = '/audio/' + [groupId, audioId].join('/') + (tab ? '/' + tab : '');
    _history.push(url);
  }

  public static setAudioTab(groupId: number, audioId: number, tab: string) {
    const url = '/audio/' + [groupId, audioId].join('/') + (tab ? '/' + tab : '');
    _history.push(url);
  }

  public static openDefault() {
    return this.openCall();
  }

  private static RETURN_URL_AFTER_SELECT_LANGS_KEY = 'returnUrlAfterSelectLangs';

  public static openInstallSelectLangs(optionParam?: string) {
    const currentPath = window.location.pathname + window.location.search;
    if (!currentPath.startsWith('/install/')) {
      sessionStorage.setItem(Navigator.RETURN_URL_AFTER_SELECT_LANGS_KEY, currentPath);
    }
    const url = '/install/selectLangs' + (!!optionParam ? '/' + optionParam : '')
    _history.push(url);
  }

  public static popReturnUrlAfterSelectLangs(): string | null {
    const url = sessionStorage.getItem(Navigator.RETURN_URL_AFTER_SELECT_LANGS_KEY);
    if (url) sessionStorage.removeItem(Navigator.RETURN_URL_AFTER_SELECT_LANGS_KEY);
    return url;
  }

  public static openUrl(url: string) {
    _history.push(url);
  }

  public static openCall(roomId?: string) {
    const url = roomId ? '/call/' + roomId : '/';
    _history.push(url);
  }

  public static openRoot() {
    _history.push('/');
  }

}
